// import { Client } from './baseurl';
// import { getToken } from './getToken';

export type AnalyticsEventType = 'paso_1' | 'paso_2' | 'paso_3' | 'paso_4';

export type AnalyticsEventPayload = {
  eventType: AnalyticsEventType;
  generalSellableVariantId?: string;
  params?: Record<string, unknown>;
};

export const postAnalyticsEvent = async (_payload: AnalyticsEventPayload): Promise<void> => {
  // Deshabilitado temporalmente: no enviar eventos al endpoint /analytics
  // const token = await getToken();
  // await Client.post('/analytics', payload, { headers: { token } });
};
